import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ef1f7de6")
const _hoisted_1 = { class: "evolution-line" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "pokemon-details__title underline-border" }, "Evolutions", -1)
const _hoisted_3 = { class: "evolution-line__line" }
const _hoisted_4 = {
  key: 0,
  class: "evolution-line__next-step"
}
const _hoisted_5 = { class: "evolution-line__pokemon-artwork-container" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "evolution-line__pokemon-name" }
const _hoisted_8 = { class: "evolution-line__pokemon-id" }
const _hoisted_9 = { class: "evolution-line__types" }
const _hoisted_10 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.evoRings, (ring) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "evolution-line__ring",
          key: ring.id
        }, [
          (ring.hasNext)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_fa, { icon: "long-arrow-alt-right" })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "evolution-line__ring-details",
            to: { name: 'PokemonDetails', params: { name: ring.name }}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: "evolution-line__pokemon-artwork",
                  src: ring.artwork,
                  alt: `${ring.name} artwork`
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("h4", _hoisted_7, _toDisplayString(ring.name), 1),
              _createElementVNode("small", _hoisted_8, "#" + _toDisplayString(ring.id), 1),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ring.types, (type) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['evolution-line__type', 'app__type-pill', `app__type-pill--${type}`]),
                    key: type
                  }, [
                    _createTextVNode(_toDisplayString(type) + " ", 1),
                    _createElementVNode("img", {
                      class: "evolution-line__type-icon app__type-pill-icon",
                      src: _ctx.loadTypeImg(type)
                    }, null, 8, _hoisted_10)
                  ], 2))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}